import { Component, OnInit, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'navigation-bar',
  templateUrl: './Navigation-bar.component.html',
})
export class NavigationBarComponent implements OnInit {
  // @Input() page?: page;
  // @Input() totalPages?: totalPages;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}
}
